module.exports = __webpack_public_path__ + "img/next.dd1bff58.svg";